import { BILLING_FIELD_LABEL_MAP } from "../modules/Master/Billing/actions/constant";



export const formatFieldName = (fieldName?: string): string => {
  if (!fieldName) return "-";

  const key = fieldName?.toLowerCase();

  if (BILLING_FIELD_LABEL_MAP[key]) {
    return BILLING_FIELD_LABEL_MAP[key];
  }

  return key
    ?.replace(/idcsv/g, "")
    ?.replace(/id/g, "")
    ?.replace(/_/g, " ")
    ?.replace(/([a-z])([A-Z])/g, "$1 $2")
    ?.replace(/\b\w/g, (char) => char.toUpperCase());
};
